<template>
  <nav class='header-wrapper'>
    <div class='container'>
      <div class='header-content'>
        <div class='logo-wrapper'>
          <router-link tag="a" :to="{ name: 'main-page'}">
            <img src="/assets/logo/brand-logo.png" alt="Musichenko" class='img-fluid'>
          </router-link>
        </div>
        <div class='text-primary c-p' v-if="hasToken" @click="clearToken()">
          Вийти з акаунта
        </div>
        <div class='nav-menu-wrapper' ref='burgerMenu'>
          <div class='main-page d-flex' v-if="isMainPage">
            <div
              v-for="menuItem of mainPageMenu"
              :key="menuItem.anchor"
              class='nav-menu-item app-text'
              @click="scrollToAnotherSection(menuItem.anchor)"
            >
              <v-icon :name='menuItem.icon' class='mr-s text-primary' scale='1.1'></v-icon>
              <span class="menu-items-text">{{ menuItem.text }}</span>
            </div>
          </div>
          <div class='products d-flex' v-if="isProductsPage">
            <div class='nav-menu-item app-text' @click="redirectToOtherPage('/')">
              <v-icon name='home' class='mr-s text-primary' scale='1.1'></v-icon>
              <span class="menu-items-text">Головна</span>
            </div>
          </div>
          <div class='product-page d-flex' v-if="isProductViewPage || isLoginPage">
            <div class='nav-menu-item app-text' @click="redirectToOtherPage('/')">
              <v-icon name='home' class='mr-s text-primary' scale='1.1'></v-icon>
              <span class="menu-items-text">Головна</span>
            </div>
            <div class='nav-menu-item app-text' @click="redirectToOtherPage('/products')">
              <v-icon name='tshirt' class='mr-s text-primary' scale='1.1'></v-icon>
              <span class="menu-items-text">Товари</span>
            </div>
          </div>
        </div>
        <div class='nav-menu-button' @click='toggleBurgetMenu' ref='burgerButton'>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import router from '@/router.js'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Header',
  data () {
    return {
      mainPageMenu: [
        { text: 'Головна', icon: 'home', anchor: 0 },
        { text: 'Про нас', icon: 'info-circle', anchor: 1 },
        { text: 'Товари', icon: 'tshirt', anchor: 2 },
        { text: 'Контакти', icon: 'map-marked-alt', anchor: 3 },
        { text: 'Зворотний звʼязок', icon: 'envelope', anchor: 4 }
      ]
    }
  },
  computed: {
    ...mapState(['hasToken']),
    isMainPage () {
      return this.$route.name === 'main-page'
    },
    isProductsPage () {
      return this.$route.name === 'products'
    },
    isProductViewPage () {
      return this.$route.name === 'product-view'
    },
    isLoginPage () {
      return this.$route.name === 'login'
    }
  },
  methods: {
    ...mapMutations(['tokenWasChanged']),
    toggleBurgetMenu () {
      this.$refs.burgerButton.classList.toggle('active')
      this.$refs.burgerMenu.classList.toggle('opened')
    },
    scrollToAnotherSection (section) {
      const sectionsArray = [
        '#mainSection',
        '#aboutSection',
        '#ourProductsSection',
        '#locationSection',
        '#feedbackFormSection'
      ]
      this.toggleBurgetMenu()
      const offsetTop = document.querySelector(sectionsArray[section]).offsetTop
      window.scroll({
        top: offsetTop - 60,
        left: 0,
        behavior: 'smooth'
      })
    },
    redirectToOtherPage (route) {
      router.push(route)
      this.toggleBurgetMenu()
    },
    clearToken () {
      localStorage.removeItem('auth_token')
      router.replace('/')
      this.tokenWasChanged(null)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';
.header-wrapper {
  background-color: $white-color;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0px 1px 1px $border-color;
  z-index: 1000;
  user-select: none;
  .header-content {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    .nav-menu-wrapper {
      .main-page, .products, .product-page, .shopping-basket {
        display: flex;
      }
      .nav-menu-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &:not(:last-child) {
          padding-right: 10px;
          margin-right: 10px;
          border-right: 1px solid $asset-color;
        }
        &:hover {
          color: $primary-color;
        }
      }
    }
    .logo-wrapper {
      img {
        height: 45px;
      }
    }
    .nav-menu-button {
    display: none;
    }
  }
}

@media(max-width: $laptop) {
  .menu-items-text {
    display: none;
  }
}

@media(max-width: $tablet) {
  .header-wrapper {
    .header-content {
      .nav-menu-wrapper {
        position: fixed;
        top: 60px;
        flex-direction: column;
        background-color: $white-color;
        left: 0;
        right: 0;
        padding: 20px;
        display: none;
        box-shadow: 0px 1px 1px $border-color;
        .main-page, .products, .product-page, .shopping-basket {
          flex-direction: column;
        }
        &.opened {
          display: flex;
        }
        .nav-menu-item {
         text-decoration: none;
         width: 100%;
         text-align: center;
         margin-bottom: 20px;
         &:not(:last-child) {
          margin-right: 0;
          border-right: 0;
          padding-right: 0;
         }
         &:last-child {
          margin-bottom: 0;
         }
        }
      }
      .nav-menu-button {
        display: flex;
        flex-direction: column;
        height: 18px;
        width: 25px;
        position: relative;
        cursor: pointer;
        span {
          display: flex;
          height: 2px;
          background-color: $primary-color;
          transition: all 0.3s ease-in-out;
          position: absolute;
          width: 25px;
          &:first-child {
            top: 0;
          }
          &:nth-child(2) {
            top: calc(9px - 1px);
          }
          &:last-child {
            bottom: 0;
          }
        }
        &.active span {
          position: absolute;
          height: 2px;
          width: 25px;
          top: calc(9px - 1px);
          &:first-child {
            transform: rotate(45deg);
          }
          &:nth-child(2) {
            transform: rotate(-45deg);
          }
          &:last-child {
            display: none;
          }
        }
      }
    }
  }
  .menu-items-text {
    display: flex;
  }
}
</style>
